/**
 * Scroll next button selector.
 * @type {string}
 */
const BUTTON_NEXT = '.x-scroll--next';

/**
 * Scroll previous button selector.
 * @type {string}
 */
const BUTTON_PREVIOUS = '.x-scroll--previous';

/**
 * This class handle scroll elements.
 *
 * @class
 */
export class XScroll {
    constructor(wrapper) {
        this.wrapper = wrapper;

        this.activeIndex = 0;

        this.scrollNext = this.wrapper.querySelector(BUTTON_NEXT);

        this.scrollPrev = this.wrapper.querySelector(BUTTON_PREVIOUS);

        this.cards = this.wrapper.querySelectorAll('.card');

        this.scrollNext.addEventListener('click', () => {
            this.moveTo('next');
        });

        this.scrollPrev.addEventListener('click', () => {
            this.moveTo('prev');
        });

        this.wrapper.addEventListener('scroll', () => {
            this.checkButtons();
        });

        this.checkActiveIndex();

        this.resizeObserver = new window.ResizeObserver(() => {
            this.checkActiveIndex();
            this.checkButtons();
        });

        this.resizeObserver.observe(this.wrapper);
    }

    /**
     * Function that moves the slide.
     *
     * @param {string} direction - Defines slider directions.
     * @returns {void}
     */
    moveTo(direction) {
        const itemWidth = this.cards[0].clientWidth;

        if (direction === 'next' && this.activeIndex < this.cards.length - 1) {
            this.activeIndex += 1;
        } else if (direction === 'prev' && this.activeIndex > 0) {
            this.activeIndex -= 1;
        }

        this.checkButtons();

        let scrolled = 0;

        const scrollElement = this.wrapper;
        const scrollTimer = setInterval(function () {
            scrollElement.style.scrollSnapType = 'initial';
            if (direction === 'next') {
                scrollElement.scrollLeft += 10;
            } else {
                scrollElement.scrollLeft -= 10;
            }
            scrolled += 10;

            if (scrolled >= itemWidth) {
                window.clearInterval(scrollTimer);
                scrollElement.style.scrollSnapType = '';
            }
        }, 5);
    }

    checkButtons() {
        const itemWidth = this.cards[0].clientWidth;
        this.activeIndex = Math.round(this.wrapper.scrollLeft / itemWidth);

        console.log(this.activeIndex);
        if (this.activeIndex === this.cards.length - this.deduct) {
            this.scrollNext.setAttribute('disabled', 'true');
        } else {
            this.scrollNext.removeAttribute('disabled');
        }

        if (this.wrapper.scrollLeft === 0) {
            this.scrollPrev.setAttribute('disabled', 'true');
        } else {
            this.scrollPrev.removeAttribute('disabled');
        }
    }

    checkActiveIndex() {
        if (this.wrapper.clientWidth < 992 && this.wrapper.clientWidth > 767) {
            this.activeIndex = 1;
            this.deduct = 2;
        } else if (this.wrapper.clientWidth <= 767) {
            this.activeIndex = 0;
            this.deduct = 1;
        }
        this.wrapper.scrollLeft = 0;
    }
}

/**
 * Scroll container selector.
 * @type {string}
 */
const SCROLL = '[data-component="x-scroll"]';

export default function _xscroll() {
    const scrolls = document.querySelectorAll(SCROLL);

    scrolls.forEach((scroll) => {
        // Create a new item to modify
        const DOMItem = scroll;

        if (DOMItem.scroll) {
            DOMItem.scroll = new XScroll(scroll);
        }
    });
}

_xscroll();
